import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

export default function AboutSection() {
  const { t } = useTranslation();

  return (
    <section className="py-20 md:py-28 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-6 md:px-12">
        <div className="flex flex-col lg:flex-row gap-12 lg:gap-16">
          <div className="lg:w-1/2 relative">
            <div className="rounded-3xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Artistic%20flatlay%20of%20fashion%20items%20including%20sneakers%20a%20watch%20sunglasses%20and%20a%20small%20bag%20arranged%20on%20a%20light%20oak%20table%2C%20warm%20sunlight%20casting%20long%20shadows%2C%20minimal%20scandinavian%20interior%20background%2C%20editorial%20lifestyle%20photography%2C%20soft%20neutral%20colors%20with%20earthy%20accents%2C%20clean%20curated%20composition&width=1200&height=900&seq=about-collage-v2-w6x7&orientation=landscape"
                alt="CSSBuy Produtos em destaque"
                className="w-full h-full object-cover"
              />
            </div>
            <div className="absolute top-4 left-4 flex flex-wrap gap-2">
              <span className="px-3 py-1.5 rounded-full bg-white/85 backdrop-blur-sm text-xs font-medium text-foreground-800 whitespace-nowrap shadow-sm">
                {t('about.tag_2026')}
              </span>
              <span className="px-3 py-1.5 rounded-full bg-white/85 backdrop-blur-sm text-xs font-medium text-foreground-800 whitespace-nowrap shadow-sm">
                {t('about.tag_taobao')}
              </span>
              <span className="px-3 py-1.5 rounded-full bg-white/85 backdrop-blur-sm text-xs font-medium text-foreground-800 whitespace-nowrap shadow-sm">
                {t('about.tag_weidian')}
              </span>
            </div>
          </div>

          <div className="lg:w-1/2 flex flex-col justify-center">
            <h2 className="font-heading text-4xl md:text-5xl text-foreground-900 leading-tight mb-6">
              {t('about.heading')}
            </h2>

            <div className="flex flex-wrap gap-3 mb-8">
              <Link
                to="/guia-cssbuy-completo"
                className="px-4 py-2 rounded-full border border-foreground-300 text-sm font-medium text-foreground-700 hover:bg-foreground-900 hover:text-white hover:border-foreground-900 transition-all duration-200 whitespace-nowrap"
              >
                Guia Completo
              </Link>
              <a
                href="https://kaspreadsheet.com/"
                target="_blank"
                rel="noopener nofollow"
                className="px-4 py-2 rounded-full text-sm font-medium text-foreground-500 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap"
              >
                Spreadsheet
              </a>
              <Link
                to="/como-usar-cssbuy"
                className="px-4 py-2 rounded-full text-sm font-medium text-foreground-500 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap"
              >
                Como Usar
              </Link>
            </div>

            <p className="text-foreground-600 leading-relaxed mb-8 text-sm md:text-base">
              {t('about.description')}
            </p>

            <div className="bg-foreground-900 rounded-2xl p-6 md:p-8 flex flex-col md:flex-row gap-6 items-start">
              <div className="flex-1">
                <span className="inline-block px-3 py-1 rounded-full bg-primary-500/20 text-primary-300 text-xs font-medium mb-3 whitespace-nowrap">
                  {t('about.card_label')}
                </span>
                <h3 className="font-heading text-xl md:text-2xl text-white font-semibold mb-2">
                  {t('about.card_title')}
                </h3>
                <p className="text-white/70 text-sm leading-relaxed">
                  {t('about.card_desc')}
                </p>
              </div>
              <div className="shrink-0 w-full md:w-[180px] h-[120px] rounded-xl overflow-hidden bg-background-100 flex items-center justify-center">
                <img
                  src="https://readdy.ai/api/search-image?query=Clean%20modern%20spreadsheet%20interface%20with%20organized%20product%20data%20rows%20and%20columns%20in%20warm%20earthy%20tones%2C%20minimal%20UI%20design%20with%20soft%20grid%20lines%2C%20professional%20data%20dashboard%20mockup%2C%20light%20background%20with%20subtle%20color%20accents&width=360&height=240&seq=spread-thumb-v2-y8z9&orientation=landscape"
                  alt="CSSBuy Spreadsheet preview"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}